import { FC, memo } from 'react'
import { Box } from '@chakra-ui/react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const GroupIconOutline = createIcon({
  displayName: 'GroupIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M13.7678,10.9822c0.976311,0.976311 0.976311,2.55922 0,3.53553c-0.976311,0.976311 -2.55922,0.976311 -3.53553,0c-0.976311,-0.976311 -0.976311,-2.55922 0,-3.53553c0.976311,-0.976311 2.55922,-0.976311 3.53553,0"></path>
        <path d="M19.2538,4.98223c0.976311,0.976311 0.976311,2.55922 0,3.53553c-0.976311,0.976311 -2.55922,0.976311 -3.53553,0c-0.976311,-0.976311 -0.976311,-2.55922 0,-3.53553c0.976311,-0.976311 2.55922,-0.976311 3.53553,0"></path>
        <path d="M18,12.25c1.533,0 3,0.533 4,1.333"></path>
        <path d="M8.28177,4.98223c0.976311,0.976311 0.976311,2.55922 0,3.53553c-0.976311,0.976311 -2.55922,0.976311 -3.53553,0c-0.976311,-0.976311 -0.976311,-2.55922 0,-3.53553c0.976311,-0.976311 2.55922,-0.976311 3.53553,0"></path>
        <path d="M2,13.583c1,-0.8 2.467,-1.333 4,-1.333"></path>
        <path d="M16.591,19.75c-1.165,-0.901 -2.839,-1.5 -4.591,-1.5c-1.752,0 -3.426,0.599 -4.591,1.5"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const GroupIconTwoTone = createIcon({
  displayName: 'GroupIconTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" strokeLinecap="round" strokeWidth="1.5" stroke="twoToneStrokeColor" fill="none" strokeLinejoin="round">
        <Box
          as="path"
          fill="twoToneLightColor"
          d="M13.7678,10.9822c0.976311,0.976311 0.976311,2.55922 0,3.53553c-0.976311,0.976311 -2.55922,0.976311 -3.53553,0c-0.976311,-0.976311 -0.976311,-2.55922 0,-3.53553c0.976311,-0.976311 2.55922,-0.976311 3.53553,0"
        ></Box>
        <Box
          as="path"
          fill="twoToneLightColor"
          d="M19.2538,4.98223c0.976311,0.976311 0.976311,2.55922 0,3.53553c-0.976311,0.976311 -2.55922,0.976311 -3.53553,0c-0.976311,-0.976311 -0.976311,-2.55922 0,-3.53553c0.976311,-0.976311 2.55922,-0.976311 3.53553,0"
        ></Box>
        <path d="M18,12.25c1.533,0 3,0.533 4,1.333"></path>
        <Box
          as="path"
          fill="twoToneLightColor"
          d="M8.28177,4.98223c0.976311,0.976311 0.976311,2.55922 0,3.53553c-0.976311,0.976311 -2.55922,0.976311 -3.53553,0c-0.976311,-0.976311 -0.976311,-2.55922 0,-3.53553c0.976311,-0.976311 2.55922,-0.976311 3.53553,0"
        ></Box>
        <path d="M2,13.583c1,-0.8 2.467,-1.333 4,-1.333"></path>
        <path d="M16.591,19.75c-1.165,-0.901 -2.839,-1.5 -4.591,-1.5c-1.752,0 -3.426,0.599 -4.591,1.5"></path>
      </Box>
      <path fill="none" d="M0,0h24v24h-24Z"></path>
    </>
  ),
})

const Group: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={GroupIconTwoTone} {...props} />
  return <CustomIcon as={GroupIconOutline} {...props} />
}

export default memo(Group)
